import React from 'react';
import { SHADCN, TYPO, FS, R } from '../theme';

// ── <LiveIndicator> — point pulsé + label ───────────────────────────────────
// Variante "live" sans pastille : juste le rond animé et un texte. À utiliser
// pour signaler un état en temps réel (ouvert, en service, en ligne…).
// Variants : success (défaut) / warning / error / info / neutral.

const COLORS = {
  success: SHADCN.success,
  warning: SHADCN.warning,
  error:   SHADCN.error,
  info:    SHADCN.info,
  neutral: SHADCN.mutedFg,
};

if (typeof document !== 'undefined' && !document.getElementById('live-indicator-pulse')) {
  const style = document.createElement('style');
  style.id = 'live-indicator-pulse';
  style.textContent = `
    @keyframes liveIndicatorPulse {
      0%   { box-shadow: 0 0 0 0 var(--live-color); }
      70%  { box-shadow: 0 0 0 6px transparent; }
      100% { box-shadow: 0 0 0 0 transparent; }
    }
    @keyframes liveIndicatorPulseDot {
      0%, 100% { opacity: 1; }
      50%      { opacity: 0.55; }
    }
  `;
  document.head.appendChild(style);
}

export default function LiveIndicator({ children, variant = 'success', style }) {
  const color = COLORS[variant] || COLORS.neutral;
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      color,
      ...TYPO.body,
      fontSize: FS.caption,
      fontWeight: 500,
      lineHeight: 1.4,
      whiteSpace: 'nowrap',
      ...style,
    }}>
      <span style={{
        width: 8,
        height: 8,
        borderRadius: R.pill,
        background: color,
        '--live-color': color,
        animation: 'liveIndicatorPulse 1.8s cubic-bezier(0.23, 1, 0.32, 1) infinite, liveIndicatorPulseDot 1.8s cubic-bezier(0.23, 1, 0.32, 1) infinite',
      }} />
      {children}
    </span>
  );
}
